var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrinttaa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-label": "printer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#05262c",
    fillRule: "evenodd",
    d: "M20.095 16.333H3.905v-3.571c0-.656.559-1.19 1.245-1.19h13.7c.686 0 1.245.534 1.245 1.19v3.571zM6.762 21.095h10.476v-2.857H6.762v2.857zm0-16.19h7.857V6.69c0 .33.293.596.655.596h1.964v2.38H6.762V4.906zm12.113 4.97V6.902c0-.498-.198-.975-.55-1.326L16.3 3.549A1.875 1.875 0 0 0 14.973 3H6.316c-.658 0-1.191.56-1.191 1.25v5.625A3.125 3.125 0 0 0 2 13v5c0 .345.28.625.625.625h2.5v3.75c0 .345.28.625.625.625h12.5c.345 0 .625-.28.625-.625v-3.75h2.5c.345 0 .625-.28.625-.625v-5c0-1.726-1.4-3.125-3.125-3.125zm-1.637 3.601a.952.952 0 1 0 0 1.905.952.952 0 0 0 0-1.905z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinttaa);
export default __webpack_public_path__ + "static/media/printtaa.39c4641e.svg";
export { ForwardRef as ReactComponent };